class StarkProductCardGallery extends HTMLElement {
  connectedCallback() {
    if (this.dataset.galleryInitialized === 'true') return;

    this.dataset.galleryInitialized = 'true';
    this.track = this.querySelector('[data-gallery-track]');
    this.slides = [...this.querySelectorAll('[data-gallery-slide]')];
    this.previousButton = this.querySelector('[data-gallery-previous]');
    this.nextButton = this.querySelector('[data-gallery-next]');
    this.status = this.querySelector('[data-gallery-status]');
    this.currentIndex = 0;
    this.pointerStartX = null;
    this.didSwipe = false;

    if (!this.track || this.slides.length < 2 || !this.previousButton || !this.nextButton) return;

    this.previousButton.addEventListener('click', () => this.show(this.currentIndex - 1));
    this.nextButton.addEventListener('click', () => this.show(this.currentIndex + 1));
    this.addEventListener('pointerdown', (event) => this.handlePointerDown(event));
    this.addEventListener('pointerup', (event) => this.handlePointerUp(event));
    this.addEventListener('pointercancel', () => this.resetPointer());
    this.addEventListener('click', (event) => {
      if (!this.didSwipe) return;
      event.preventDefault();
      this.didSwipe = false;
    }, true);
    this.addEventListener('keydown', (event) => this.handleKeyboard(event));
    this.show(0, false);
  }

  show(index, animate = true) {
    const slideCount = this.slides.length;
    this.currentIndex = (index + slideCount) % slideCount;
    this.track.style.transitionDuration = animate ? '' : '0s';
    this.track.style.transform = `translateX(-${this.currentIndex * 100}%)`;

    this.slides.forEach((slide, slideIndex) => {
      const isCurrent = slideIndex === this.currentIndex;
      slide.setAttribute('aria-hidden', String(!isCurrent));
      slide.tabIndex = isCurrent ? 0 : -1;
    });

    if (this.status) this.status.textContent = `${this.currentIndex + 1} / ${slideCount}`;
  }

  handlePointerDown(event) {
    if (event.pointerType === 'mouse' && event.button !== 0) return;
    this.pointerStartX = event.clientX;
    this.didSwipe = false;
  }

  handlePointerUp(event) {
    if (this.pointerStartX === null) return;
    const distance = event.clientX - this.pointerStartX;
    this.resetPointer();

    if (Math.abs(distance) < 35) return;
    this.didSwipe = true;
    this.show(this.currentIndex + (distance < 0 ? 1 : -1));
  }

  resetPointer() {
    this.pointerStartX = null;
  }

  handleKeyboard(event) {
    if (event.key === 'ArrowLeft') {
      event.preventDefault();
      this.show(this.currentIndex - 1);
    } else if (event.key === 'ArrowRight') {
      event.preventDefault();
      this.show(this.currentIndex + 1);
    }
  }
}

if (!customElements.get('stark-product-card-gallery')) {
  customElements.define('stark-product-card-gallery', StarkProductCardGallery);
}
